import { NgModule } from '@angular/core'
import { Routes, RouterModule } from '@angular/router'
import { HomeComponent } from './shared/components/home/home.component'
import { WhyUsComponent } from './modules/why-us/why-us.component'
import { CreditToolsComponent } from './modules/credit-tools/credit-tools.component'
import { PoliciesComponent } from './modules/policies/policies.component'
import { ArticleComponent } from './shared/components/article/article.component'
import { NotFoundComponent } from './NotFound.component'
import { ActivationComponent } from './shared/components/activation/activation.component'

import {WebPreQualOptionsGetPhoneNumberComponent} from './shared/components/web-prequal-options-get-phonenumber/web-prequal-options-get-phonenumber.component'
const routes: Routes = [
 // { path: '', loadChildren:  () => import( './verticals/dental/dental.module').then(x => x.DentalModule) },
 // { path: 'hsfs', loadChildren:  () => import( './verticals/hsfs/hsfs.module').then(x => x.HsfsModule) },
   //ICREDIT-29299:: Temporarily Disabled as per requirement { path: 'account-activation', component: ActivationComponent },
   { path: 'home-page', component: HomeComponent },
   { path: '', component: HomeComponent }, 

  //{ path: 'hsfs-account-activation', component: ActivationComponent },

    { path: 'getphonenumber', component: WebPreQualOptionsGetPhoneNumberComponent },
    { path: '', component: HomeComponent },
  
    { 
      path: 'why-us',
      loadChildren: () => import('./modules/why-us/why-us.module').then((m) => m.WhyUsModule)
    },
    { 
      path: 'credit-tools',
      loadChildren: () => import('./modules/credit-tools/credit-tools.module').then((m) => m.CreditToolsModule)
    },
    { 
      path: 'policies',
      loadChildren: () => import('./modules/policies/policies.module').then((m) => m.PoliciesModule)
    },
    {
      path: 'fraud-affidavit',
      loadChildren: () => import('./modules/fraud-affidavit/fraud-affidavit.module').then((m) => m.FraudAffidavitModule),
    },
    {
      path: 'faq',
      loadChildren: () => import('./modules/faq/faq.module').then((m) => m.FaqModule),
    },
    {
      path: 'press',
      loadChildren: () => import('./modules/press-release/press-release.module').then((m) => m.PressReleaseModule),
    },
    {
      path: 'account',
      outlet: 'modal',
      loadChildren: () => import('./modules/account/account.module').then((m) => m.AccountModule),
    }, 
  { path: 'article/:url', component: ArticleComponent },
  { path: '404', component: NotFoundComponent },
  { path: '**', component: NotFoundComponent }, 
]

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking',
    anchorScrolling: 'enabled'
}),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
